import { institutions } from './data';

declare var angular: any;

angular.module('PartnersControllers').controller('PartnersListCtrl', [
  '$scope',
  'navbar',
  'partners',
  function($scope, navbar, partners) {
    $scope.isRootPath = window.location.pathname === '/';

    if ($scope.main.me) {
      navbar.goBackAction('Accueil', '#!/', 'navbar.home');
    }

    $scope.partners = institutions.filter(
      i => i.logo?.length && i.show !== false
    );
  }
]);
